import React from 'react';
import StoreProvider from './StoreProvider';
import PreviewConfigProvider from './PreviewConfigProvider';
import { PreviewConfig, AppSettings } from 'types';

export interface HawksearchPreviewProps {
	config: PreviewConfig;
	settings: AppSettings;
	siteDirectory: string;
	children: React.ReactNode;
}

function HawksearchPreview(props: HawksearchPreviewProps) {
	return (
		<PreviewConfigProvider previewConfig={props.config} appSettings={props.settings}>
			<StoreProvider siteDirectory={props.siteDirectory}>{props.children}</StoreProvider>
		</PreviewConfigProvider>
	);
}

export default HawksearchPreview;
